module.exports = __webpack_public_path__ + "static/media/xmas-background-modern-lowerOpac.747ca089.svg";